export default __webpack_public_path__ + "static/media/ui-flipped.fa5289ab.png";